'use strict';
var globalThis = require('../internals/global-this');

module.exports = globalThis.Promise;



//////////////////
// WEBPACK FOOTER
// ./~/core-js/internals/promise-native-constructor.js
// module id = 107
// module chunks = 0